/* eslint-disable */

export const CommercePaymentActionKind = {
  None: 'none',
  ConfirmCard: 'confirm_card',
  ConfirmWallet: 'confirm_wallet',
  ConfirmAch: 'confirm_ach',
  Redirect: 'redirect'
} as const;
export type CommercePaymentActionKind = typeof CommercePaymentActionKind[keyof typeof CommercePaymentActionKind];
